// Header namespace: nav labels + the language switcher chrome.
const header = {
  nav: {
    home: 'Home',
    about: 'About',
    resume: 'Resume',
    projects: 'Projects',
    services: 'Services',
    blog: 'Blog',
    now: 'Now',
  },
  language: {
    label: 'Language',
    en: 'English',
    sk: 'Slovak',
    cs: 'Czech',
  },
};

export default header;
